import { Stack } from '@mui/material'
import { TableCellProps } from '@mui/material/TableCell/TableCell'
import { roundingNumber } from 'components/shared/processes'
import { Limpness } from 'models/IFarm'
import { CustomTableRowProps } from 'ui/table/CustomTableRow'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'

interface useGetCellOptionsProps {
	limpness: Limpness[]
	totalCattle?: number
}

export const useGetCellOptions = ({
	limpness,
	totalCattle = 0,
}: useGetCellOptionsProps) => {
	const TABLE_OPTIONS: CustomTableRowProps[] = limpness?.map(el => ({
		rowKey: 'tableFatnessWidgetRow',
		rowHeight: '18px',
		cellItems: [
			{
				padding: '4px 0px 0px 0px',
				children: (
					<Stack direction='row' alignItems='center' gap='4px'>
						<span
							style={{
								width: '8px',
								height: '8px',
								backgroundColor: el.color,
								borderRadius: '50%',
							}}
						></span>
						<TypographyPrimary>{el.label}</TypographyPrimary>
					</Stack>
				),
				align: 'left' as TableCellProps['align'],
			},
			{
				padding: '4px 0px 0px 0px',
				children:
					el.value === 0
						? 0
						: (el.value ?? <TypographyPrimary>Нет данных</TypographyPrimary>),
				align: 'left' as TableCellProps['align'],
			},
			{
				padding: '4px 0px 0px 0px',
				children:
					totalCattle === 0
						? '-'
						: roundingNumber((el.value / totalCattle) * 100, 0),
				align: 'right' as TableCellProps['align'],
			},
		],
	}))
	return TABLE_OPTIONS
}
